import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { DatePipe } from '@angular/common';
import { Globals } from "../../globals";
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoadingController } from 'ionic-angular';
import * as moment from 'moment';

@Injectable()

export class CustomServices {

  public firestore: any;
  limit_pages: number = 1;
  page_active: number = 1;
  pagesTickets: any;
  tickets_array: any;
  filteredTicketActive: boolean = false;
  filteredTicket: any;
  get_tickets_done: boolean = false;
  list_tickets: any;
  first_ticket_name: any;
  arrosseria_tickets: any = [];
  loader_arrosseria_tickets: boolean = false;

  constructor(public afs: AngularFirestore,
    public datePipe: DatePipe,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController) {
    this.firestore = firebase.firestore();
  }

  /**********************************************************/
  /*                       ARROSSERIA                       */
  /**********************************************************/

  searchTicketsNode(value, type, date_first, date_last) {
    if (value.target.value == '' || value.target.value == undefined) {
      this.filteredTicketActive = false;
    } else {
      if (value.target.value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('type', type)
          .set('filter_string', value.target.value.toLowerCase())
          .set('datetime_init', date_first)
          .set('datetime_final', date_last);

        this.http.post(this.globals.analytics_path + 'filter/tickets', params, {})
          .subscribe(async res => {
            this.filteredTicket = res;
            this.filteredTicket = this.filteredTicket.filter(ticket => ticket.takeaway_rappel === true);
            this.filteredTicketActive = true;
          });
      } else {
        this.filteredTicketActive = false;
      }
    }
  }

  async getPagesTickets(elements_per_page, type, date_first, date_last) {
    this.get_tickets_done = false;
    this.filteredTicketActive = false;
    this.limit_pages = elements_per_page;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('type', type)
      .set('elements_per_page', elements_per_page)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);
    await this.http.post(this.globals.analytics_path + 'paginate/tickets', params, {})
      .subscribe(async res => {
        //list
        this.list_tickets = res['list_tickets'];
        this.list_tickets = this.list_tickets.filter(ticket => ticket.takeaway_rappel === true);
        //pages
        var pages = Math.ceil(this.list_tickets.length / elements_per_page);
        this.pagesTickets = Array(pages).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        if (this.pagesTickets != 0) {
          this.getListTickets();
        } else {
          this.filteredTicketActive = true;
          this.get_tickets_done = true;
        }
      });
  }

  getListTickets() {
    this.get_tickets_done = true;
    //Search for first element to start
    this.first_ticket_name = (this.page_active - 1) * this.limit_pages;
    //We slice the array with the first element, and the first element plus the limit to get the last index
    this.tickets_array = this.list_tickets.slice(this.first_ticket_name, this.first_ticket_name + this.limit_pages);
  }

  async searchArrosseriaTickets() {
    this.arrosseria_tickets = [];
    this.loader_arrosseria_tickets = false;
    var date_first = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    var date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    const ticketsRef = this.firestore.collection('tickets');

    await ticketsRef
      .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
      .where('takeaway_rappel', '==', true)
      .where('takeaway_stripe_refund', '==', false)
      .where('date', '>', new Date(date_first))
      .where('date', '<', new Date(date_last))
      .orderBy('date', 'desc')
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var _ticket = doc.data();
          _ticket.UID = doc.id;

          this.arrosseria_tickets.push(_ticket);
        });
      });

    this.loader_arrosseria_tickets = true;
  }

}


// WEBPACK FOOTER //
// ./src/pages/custom/services.ts